const TYPE = {
  alert: 'ALERT',
  confirm: 'CONFIRM',
  tip: 'TIP'
};

const EMIT = {
  alert: 'CONFIRMALERT',
  cancel: 'CANCELCONFIRM',
  confirm: 'CONFIRMCONFIRM',
  tip: 'closeTip'
}

const NAME = 'zm-alert'

const TIPTIME = 1500

export {
  TYPE,
  EMIT,
  NAME,
  TIPTIME
}